<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2" d="m3 5.999 5 5 5-5"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-arrow-down',
});
</script>
